import React from 'react';
import { connect } from 'react-redux';
import { Typography } from '@mui/material';
import { Page, Row } from '../util/Page';

import './sandbox-request.css';
import creature from '../../icons/onboard-creature.png';

const SandboxRequest = ({ userLoggedIn }) => (
  <Page name="sandbox-request">
    <Row>
      <Typography variant="h5">Sandbox Access Required</Typography>
    </Row>
    {userLoggedIn && (
      <>
        <Row>
          <img src={creature} alt="red monster" className="creature" />
        </Row>
        <Row>
          <p>Whoops, looks like your account doesn&apos;t have access to this site</p>
        </Row>
      </>
    )}
    <Row>
      <p>
        If you&apos;d like to explore our data APIs please request access to our sandbox environment
        by sending us an email at <a href="support@onboarddata.io">support@onboarddata.io</a> or by
        filling out our <a href="https://www.onboarddata.io/apirequest">API Key Request Form</a>
      </p>
    </Row>
    <Row>
      <p>
        Thanks!
        <br />
        The Onboard Team
      </p>
    </Row>
  </Page>
);

export default connect(({ user: { jwt } }) => ({ userLoggedIn: jwt !== undefined }))(
  SandboxRequest
);
